/**
 * Riscaldamento dell'immobile.
 *
 * La colonna `properties.heating_type` esiste dalla prima migrazione ma nessun
 * campo dell'amministrazione la scrive: è vuota su tutti gli immobili. Il dato
 * vero sta nelle dotazioni, dove l'agente spunta "Riscaldamento Autonomo" o
 * "Riscaldamento centralizzato". Il feed XML per i portali legge già da lì.
 *
 * Questa funzione tiene insieme le due fonti: se un giorno la colonna verrà
 * compilata a mano (un "a pavimento", un "a pompa di calore") quel valore
 * vince, altrimenti si guarda alle dotazioni.
 */

/** Etichette da mostrare sotto la voce "Riscaldamento", senza ripetere la parola. */
const ETICHETTE: Record<string, string> = {
  'riscaldamento autonomo': 'Autonomo',
  'riscaldamento centralizzato': 'Centralizzato',
};

/** Le dotazioni arrivano in due forme: già appiattite da useProperty e dalla
 *  funzione di anteprima, oppure annidate dentro property_features. */
const estraiDotazioni = (property: any): any[] => {
  if (Array.isArray(property?.features)) return property.features;
  if (Array.isArray(property?.property_features)) {
    return property.property_features.map((pf: any) => pf?.features).filter(Boolean);
  }
  return [];
};

export const getHeatingLabel = (property: any): string | null => {
  const dichiarato = typeof property?.heating_type === 'string' ? property.heating_type.trim() : '';
  if (dichiarato) return dichiarato;

  const nomi = estraiDotazioni(property)
    .map((feature: any) => (typeof feature?.name === 'string' ? feature.name : ''))
    .filter((nome: string) => nome.toLowerCase().startsWith('riscaldamento'));

  if (!nomi.length) return null;

  return nomi.map((nome: string) => ETICHETTE[nome.toLowerCase()] || nome).join(', ');
};
